import { call, put, takeLatest, all } from 'redux-saga/effects';
import { PRODUCT_TAG_SEARCH } from '../actions/productTag/action_types';
import * as apiErrorActions from 'redux/actions/apiError';
import * as productTagService from '../services/productTag';
import * as listActions from 'redux/actions/list';

function* search() {
  yield takeLatest(PRODUCT_TAG_SEARCH, function*(action) {
    try {
      let productTags = yield call(productTagService.search, action.payload);
      yield put(listActions.listLoaded(productTags));
    } catch (err) {
      yield apiErrorActions.handle(err);
    }
  });
}

export default function* productTagSagas() {
  yield all([search()]);
}
